/* ================ kajal added slick slider code start ================ */
function loadSlider(parent_selector, item_selector){
  //console.log($(parent_selector).hasClass('slick-initialized'));
  if($(parent_selector).hasClass('slick-initialized')){
    $(parent_selector).slick('unslick');
  }
  let len = $(parent_selector+' '+item_selector).length;
  if(len > 0){
    let items_desk = (len >= 5) ? 5 : len;
    let items_600 = (len >= 2) ? 2 : len;
    let items_768 = (len >= 3) ? 3 : len;
    let items_990 = (len >= 3) ? 3 : len;
    let items_1200 = (len >= 4) ? 4 : len;
    $(parent_selector).slick({
      dots: false,
      infinite: false,
      arrows: true,
      slidesToShow: items_desk,
      slidesToScroll: 1,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: items_600,
            slidesToScroll: 1,
          }
        },          
        {
          breakpoint: 768,
          settings: {
            slidesToShow: items_768,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: items_990,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: items_1200,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }
}
/* ================ kajal added slick slider code end ================ */


//================== pincode code start =================

function fetchConfig() {
  var data = JSON.parse(document.getElementById('shopify-features').textContent);
  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json, text/html, text/plain, */*',
      'X-Shopify-Storefront-Access-Token': data.accessToken,
      'X-Shopify-Access-Token': data.accessToken
    }
  }
}

function verifyPincodeAjax(path,pincode){
  const config = fetchConfig();
  config.method = 'POST';
  let param= {
    'pincode': pincode,
    'shop_name': Shopify.shop
  }
  config.body = JSON.stringify(param);
  fetch(path, config)
    .then((response) => response.json())
    .then((response) => {
    return pincodeBox(response,pincode);
  });
}

function getPincodeProducts(path,pincode){
  const config = fetchConfig();
  fetch(path, config)
    .then((response) => response.json())
    .then((response) => {
    return pincodeBox(response,pincode);
  });
}

function loadPincodeProducts(){
  var pincode = localStorage.getItem('pincode');
  const config = fetchConfig();
  if((typeof pincode != undefined) && (typeof pincode != 'undefined') && (pincode != null) && (pincode != '')){
    config.method = "POST";
    let param = {
      'pincode' : pincode,
      'shop_name' : Shopify.shop
    };
    config.body = JSON.stringify(param);
    fetch('https://'+Shopify.app_url+'/pincode_productdata', config)
      .then((response) => response.json())
      .then((response) => {
        pincode_products = response;
        jQuery(".ppincode").html(pincode);

        // will be removed after ajax got working
        //pincode_products = JSON.parse('{"products":{"7138293186743":{"title":"Belagavi Kunda","handle":"belagavi-kunda","published_at":"2022-05-06T17:32:47+05:30","vendor":"Camp Purohit","product_type":"Sweets","tags":["Belgaum","Karnataka","Kunda","sweets","Traditional Sweet"],"variants":[{"id":41211456618679,"title":"500gms","option1":"500gms","option2":"None","option3":"None","sku":"SWD123","image_id":"None","inventory_quantity":"15","price":"350.00","grams":0,"admin_graphql_api_id":"gid://shopify/ProductVariant/43006978785532","compare_at_price":"560.00"}],"images":[{"id":31558886129847,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/66.png?v=1651838498"},{"id":31558886097079,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/67.png?v=1651838498"}],"options":[{"name":"Pack","position":1,"values":["500gms"]}]},"7138292662455":{"title":"Love You Maa!","handle":"md-2","published_at":"2022-05-06T17:22:00+05:30","vendor":"SweeDesi","product_type":"Gifts","tags":["Festivals","Mother Day"],"variants":[{"id":41211454849207,"title":"Per Pack","option1":"Per Pack","option2":"None","option3":"None","sku":"SWD122","image_id":"None","inventory_quantity":"15","price":"251.00","grams":0,"admin_graphql_api_id":"gid://shopify/ProductVariant/43006978785532","compare_at_price":"None"}],"images":[{"id":31558881575095,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/6_e58eed46-363d-432f-bcd5-1901f38d781b.jpg?v=1651837914"}],"options":[{"name":"Size","position":1,"values":["Per Pack"]}]},"7138292433079":{"title":"Thank You Maa!","handle":"md-1","published_at":"2022-05-06T17:16:13+05:30","vendor":"SweeDesi","product_type":"Gifts","tags":["Festivals","Mother Day"],"variants":[{"id":41211454193847,"title":"Per Pack","option1":"Per Pack","option2":"None","option3":"None","sku":"SWD121","image_id":"None","inventory_quantity":"15","price":"399.00","grams":0,"admin_graphql_api_id":"gid://shopify/ProductVariant/43006978785532","compare_at_price":"None"}],"images":[{"id":31558876627127,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/61.png?v=1651837510"},{"id":31558876594359,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/60.png?v=1651837509"}],"options":[{"name":"Size","position":1,"values":["Per Pack"]}]},"6983964885175":{"title":"Dry Petha","handle":"dry-petha","published_at":"2022-06-04T12:32:11+05:30","vendor":"SweeDesi","product_type":"Sweets","tags":["Agra"],"variants":[{"id":40691887440055,"title":"500gm","option1":"500gm","option2":"None","option3":"None","sku":"SWD017","image_id":"None","available":false,"price":"199.00","grams":500,"admin_graphql_api_id":"gid://shopify/ProductVariant/43006978785532","compare_at_price":"None"}],"images":[{"id":31030496034999,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/59.jpg?v=1635418040"}],"options":[{"name":"Pack","position":1,"values":["500gm"]}]},"7130535821495":{"title":"Rawat Malai Ghewar : DIY","handle":"rawat-malai-ghewar-diy","published_at":"2022-04-19T16:38:23+05:30","vendor":"Rawat Mishthan Bhandar","product_type":"Sweets","tags":["Gangaur","Jaipur","Sawan","Sinjhara","Teej","Traditional Sweet"],"variants":[{"id":41177122111671,"title":"1 Pc/Pack","option1":"1 Pc/Pack","option2":"None","option3":"None","sku":"SWD120","image_id":"None","inventory_quantity":"15","price":"600.00","grams":0,"admin_graphql_api_id":"gid://shopify/ProductVariant/43006978785532","compare_at_price":"None"}],"images":[{"id":31523230384311,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/29.png?v=1650366481"},{"id":31523230482615,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/30_b9407189-7404-406e-a87e-ed821ad19850.png?v=1650366482","width":1080,"height":1080},{"id":31523230449847,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/SweeDesiProducts2_9d03db2c-e935-47e8-97c9-1ae3903d9e1b.png?v=1650366481"},{"id":31523230417079,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/31_5a35635d-9fdd-4efc-9b2c-7d68aad4b1bb.png?v=1650366481"}],"options":[{"name":"Pack","position":1,"values":["1 Pc/Pack"]}]},"7120658890935":{"title":"1989 document 4th | not for sale","handle":"1989-document-4th","published_at":null,"vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43006978785532","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"3.00","grams":"0","image_id":"None","inventory_quantity":"-602","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43006978785532"}],"images":[{"id":"37372904177916","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/ceb8f36190b9124428023a06f6a877ad.jpg?v=1651314005"}],"options":{"name":"Title","position":"1","values":["Default Title"]}},"6983960789175":{"title":"1989 document oldpage","handle":"1989-document-oldpage","published_at":"2022-04-30T15:49:58+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43006978326780","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"3.00","grams":"0","image_id":"None","inventory_quantity":"-1","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43006978326780"}],"images":[{"id":"37372903325948","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/660c3ec191b4b90008aa212abdeae63f.jpg?v=1651313998"}],"options":{"name":"Title","position":"1","values":["Default Title"]}},"7013991317687":{"title":"Adam letter Ledger","handle":"adam-letter-ledger-1","published_at":"2022-05-28T15:43:56+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43119030370556","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"8956","price":"8.00","grams":"0","image_id":"None","inventory_quantity":"-3","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43119030370556"}],"images":[],"options":{"name":"Title","position":"1","values":["Default Title"]}},"6983944962231":{"title":"adam product download","handle":"adam-product-download","published_at":"2022-05-28T17:09:01+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43119090925820","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"5.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43119090925820"}],"images":[{"id":"37549142049020","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/9b174e6ba213c6c4efb8162a0096e148.jpg?v=1653737941"}],"options":{"name":"Title","position":"1","values":["Default Title"]}},"6983908786359":{"title":"adam product image","handle":"adam-product-image","published_at":"2022-05-28T17:09:05+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43119090958588","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"5.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43119090958588"}],"images":[],"options":{"name":"Title","position":"1","values":["Default Title"]}},"6983861010615":{"title":"Adam product Ledger","handle":"adam-product-ledger","published_at":"2022-05-28T15:40:18+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"new","variants":[{"id":"43119029289212","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"5.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43119029289212"}],"images":[{"id":"37548958056700","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/b06956df2ec63828f94a53e4a0ed420b.jpg?v=1653732618"}],"options":{"name":"Title","position":"1","values":["Default Title"]}},"7107373269175":{"title":"Borsa a spalla","handle":"18k-fluid-lines-necklace","published_at":"2022-01-18T14:45:02+05:30","vendor":"Supply Dark","product_type":"Necklace","tags":"White Gold","variants":[{"id":"43172263788796","title":"black","option1":"black","option2":"None","option3":"None","sku":"","price":"749.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43172263788796"},{"id":"43172272341244","title":"pink","option1":"pink","option2":"None","option3":"None","sku":"","price":"749.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43172272341244"}],"images":[{"id":"36615288094972","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/n9-927659-cognac-borsa-spalla-gianni-conti_5d534f8b-6a77-40fd-9553-ea421902d44b.jpg?v=1645449883"},{"id":"37609230401788","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/2.jpg?v=1654682065"}],"options":{"name":"Color","position":"1","values":["black","pink"]}},"6983899742391":{"title":"Borsa a spalla / tracolla","handle":"18k-dangling-obsidian-earrings","published_at":"2022-01-18T14:45:01+05:30","vendor":"Supply Dark","product_type":"Earrings","tags":"White Gold","variants":[{"id":"42438236537084","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"1234565","price":"829.00","grams":"0","image_id":"None","inventory_quantity":"50","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/42438236537084"}],"images":[{"id":"36615278985468","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/n5-MR300-NUDO-borsa-spalla-pelletteria-veneta_705e5c0e-a594-4fcf-b3b6-b68cbd666388.jpg?v=1643000231"}],"options":{"name":"Title","position":"1","values":["Default Title"]}},"7130535821495":{"title":"cup add","handle":"cup-add","published_at":"2022-05-28T17:14:52+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43119097348348","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"9.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43119097348348"}],"images":[],"options":{"name":"Title","position":"1","values":["Default Title"]}},"7138292433079":{"title":"dscvdfvfdv Step-4-Add-the-order-lookup-snippet-to-your-website","handle":"dscvdfvfdv-step-4-add-the-order-lookup-snippet-to-your-website","published_at":"2022-05-28T17:24:45+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43119107997948","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"65.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43119107997948"}],"images":[{"id":"37549195198716","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/936f22b767a86e456ffda4c62e41ff52.jpg?v=1653738885"}],"options":{"name":"Title","position":"1","values":["Default Title"]}},"6983883063479":{"title":"live test oldpage","handle":"live-test-oldpage","published_at":"2022-04-30T15:50:12+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43006978883836","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"3.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"5.00","admin_graphql_api_id":"gid://shopify/ProductVariant/43006978883836"}],"images":[{"id":"37372904472828","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/4d5eeecc6352a81be06530bee3bee32d.jpg?v=1651314012"}],"options":{"name":"Title","position":"1","values":["Default Title"]}}}}');
        //refreshCarouselListings(pincode_products,pincode);
        //updateAddtocart(pincode_products,pincode)
        if(location.pathname == "/cart"){
          //refreshCart(pincode_products,pincode);
        }
        if(location.pathname.indexOf('/products/') > -1){
//           Shopify.Products.showRecentlyViewed(
//             {
//               howManyToShow: 10,
//               wrapperId: 'recently_viewed_products_box',
//               onComplete: ''
//             }
//           );
        }
      });
  }else{
    jQuery(".ppincode").html('select location');
    jQuery('.pin_icon').trigger('click');
    pincode = '000000';
    config.method= "POST";
    let param = {
      'pincode' : pincode,
      'shop_name' : Shopify.shop
    };
    config.body = JSON.stringify(param);
    fetch('https://'+Shopify.app_url+'/pincode_productdata', config)
      .then((response) => response.json())
      .then((response) => {
        pincode_products = response;

        // will be removed after ajax got working
        //pincode_products = JSON.parse('{"products":{"7138293186743":{"title":"Belagavi Kunda","handle":"belagavi-kunda","published_at":"2022-05-06T17:32:47+05:30","vendor":"Camp Purohit","product_type":"Sweets","tags":["Belgaum","Karnataka","Kunda","sweets","Traditional Sweet"],"variants":[{"id":41211456618679,"title":"500gms","option1":"500gms","option2":"None","option3":"None","sku":"SWD123","image_id":"None","inventory_quantity":"15","price":"350.00","grams":0,"admin_graphql_api_id":"gid://shopify/ProductVariant/43006978785532","compare_at_price":"560.00"}],"images":[{"id":31558886129847,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/66.png?v=1651838498"},{"id":31558886097079,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/67.png?v=1651838498"}],"options":[{"name":"Pack","position":1,"values":["500gms"]}]},"7138292662455":{"title":"Love You Maa!","handle":"md-2","published_at":"2022-05-06T17:22:00+05:30","vendor":"SweeDesi","product_type":"Gifts","tags":["Festivals","Mother Day"],"variants":[{"id":41211454849207,"title":"Per Pack","option1":"Per Pack","option2":"None","option3":"None","sku":"SWD122","image_id":"None","inventory_quantity":"15","price":"251.00","grams":0,"admin_graphql_api_id":"gid://shopify/ProductVariant/43006978785532","compare_at_price":"None"}],"images":[{"id":31558881575095,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/6_e58eed46-363d-432f-bcd5-1901f38d781b.jpg?v=1651837914"}],"options":[{"name":"Size","position":1,"values":["Per Pack"]}]},"7138292433079":{"title":"Thank You Maa!","handle":"md-1","published_at":"2022-05-06T17:16:13+05:30","vendor":"SweeDesi","product_type":"Gifts","tags":["Festivals","Mother Day"],"variants":[{"id":41211454193847,"title":"Per Pack","option1":"Per Pack","option2":"None","option3":"None","sku":"SWD121","image_id":"None","inventory_quantity":"15","price":"399.00","grams":0,"admin_graphql_api_id":"gid://shopify/ProductVariant/43006978785532","compare_at_price":"None"}],"images":[{"id":31558876627127,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/61.png?v=1651837510"},{"id":31558876594359,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/60.png?v=1651837509"}],"options":[{"name":"Size","position":1,"values":["Per Pack"]}]},"6983964885175":{"title":"Dry Petha","handle":"dry-petha","published_at":"2022-06-04T12:32:11+05:30","vendor":"SweeDesi","product_type":"Sweets","tags":["Agra"],"variants":[{"id":40691887440055,"title":"500gm","option1":"500gm","option2":"None","option3":"None","sku":"SWD017","image_id":"None","available":false,"price":"199.00","grams":500,"admin_graphql_api_id":"gid://shopify/ProductVariant/43006978785532","compare_at_price":"None"}],"images":[{"id":31030496034999,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/59.jpg?v=1635418040"}],"options":[{"name":"Pack","position":1,"values":["500gm"]}]},"7130535821495":{"title":"Rawat Malai Ghewar : DIY","handle":"rawat-malai-ghewar-diy","published_at":"2022-04-19T16:38:23+05:30","vendor":"Rawat Mishthan Bhandar","product_type":"Sweets","tags":["Gangaur","Jaipur","Sawan","Sinjhara","Teej","Traditional Sweet"],"variants":[{"id":41177122111671,"title":"1 Pc/Pack","option1":"1 Pc/Pack","option2":"None","option3":"None","sku":"SWD120","image_id":"None","inventory_quantity":"15","price":"600.00","grams":0,"admin_graphql_api_id":"gid://shopify/ProductVariant/43006978785532","compare_at_price":"None"}],"images":[{"id":31523230384311,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/29.png?v=1650366481"},{"id":31523230482615,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/30_b9407189-7404-406e-a87e-ed821ad19850.png?v=1650366482","width":1080,"height":1080},{"id":31523230449847,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/SweeDesiProducts2_9d03db2c-e935-47e8-97c9-1ae3903d9e1b.png?v=1650366481"},{"id":31523230417079,"variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0599/0206/6871/products/31_5a35635d-9fdd-4efc-9b2c-7d68aad4b1bb.png?v=1650366481"}],"options":[{"name":"Pack","position":1,"values":["1 Pc/Pack"]}]},"7120658890935":{"title":"1989 document 4th | not for sale","handle":"1989-document-4th","published_at":null,"vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43006978785532","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"3.00","grams":"0","image_id":"None","inventory_quantity":"-602","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43006978785532"}],"images":[{"id":"37372904177916","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/ceb8f36190b9124428023a06f6a877ad.jpg?v=1651314005"}],"options":{"name":"Title","position":"1","values":["Default Title"]}},"6983960789175":{"title":"1989 document oldpage","handle":"1989-document-oldpage","published_at":"2022-04-30T15:49:58+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43006978326780","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"3.00","grams":"0","image_id":"None","inventory_quantity":"-1","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43006978326780"}],"images":[{"id":"37372903325948","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/660c3ec191b4b90008aa212abdeae63f.jpg?v=1651313998"}],"options":{"name":"Title","position":"1","values":["Default Title"]}},"7013991317687":{"title":"Adam letter Ledger","handle":"adam-letter-ledger-1","published_at":"2022-05-28T15:43:56+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43119030370556","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"8956","price":"8.00","grams":"0","image_id":"None","inventory_quantity":"-3","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43119030370556"}],"images":[],"options":{"name":"Title","position":"1","values":["Default Title"]}},"6983944962231":{"title":"adam product download","handle":"adam-product-download","published_at":"2022-05-28T17:09:01+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43119090925820","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"5.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43119090925820"}],"images":[{"id":"37549142049020","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/9b174e6ba213c6c4efb8162a0096e148.jpg?v=1653737941"}],"options":{"name":"Title","position":"1","values":["Default Title"]}},"6983908786359":{"title":"adam product image","handle":"adam-product-image","published_at":"2022-05-28T17:09:05+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43119090958588","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"5.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43119090958588"}],"images":[],"options":{"name":"Title","position":"1","values":["Default Title"]}},"6983861010615":{"title":"Adam product Ledger","handle":"adam-product-ledger","published_at":"2022-05-28T15:40:18+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"new","variants":[{"id":"43119029289212","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"5.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43119029289212"}],"images":[{"id":"37548958056700","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/b06956df2ec63828f94a53e4a0ed420b.jpg?v=1653732618"}],"options":{"name":"Title","position":"1","values":["Default Title"]}},"7107373269175":{"title":"Borsa a spalla","handle":"18k-fluid-lines-necklace","published_at":"2022-01-18T14:45:02+05:30","vendor":"Supply Dark","product_type":"Necklace","tags":"White Gold","variants":[{"id":"43172263788796","title":"black","option1":"black","option2":"None","option3":"None","sku":"","price":"749.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43172263788796"},{"id":"43172272341244","title":"pink","option1":"pink","option2":"None","option3":"None","sku":"","price":"749.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43172272341244"}],"images":[{"id":"36615288094972","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/n9-927659-cognac-borsa-spalla-gianni-conti_5d534f8b-6a77-40fd-9553-ea421902d44b.jpg?v=1645449883"},{"id":"37609230401788","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/2.jpg?v=1654682065"}],"options":{"name":"Color","position":"1","values":["black","pink"]}},"6983899742391":{"title":"Borsa a spalla / tracolla","handle":"18k-dangling-obsidian-earrings","published_at":"2022-01-18T14:45:01+05:30","vendor":"Supply Dark","product_type":"Earrings","tags":"White Gold","variants":[{"id":"42438236537084","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"1234565","price":"829.00","grams":"0","image_id":"None","inventory_quantity":"50","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/42438236537084"}],"images":[{"id":"36615278985468","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/n5-MR300-NUDO-borsa-spalla-pelletteria-veneta_705e5c0e-a594-4fcf-b3b6-b68cbd666388.jpg?v=1643000231"}],"options":{"name":"Title","position":"1","values":["Default Title"]}},"7130535821495":{"title":"cup add","handle":"cup-add","published_at":"2022-05-28T17:14:52+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43119097348348","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"9.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43119097348348"}],"images":[],"options":{"name":"Title","position":"1","values":["Default Title"]}},"7138292433079":{"title":"dscvdfvfdv Step-4-Add-the-order-lookup-snippet-to-your-website","handle":"dscvdfvfdv-step-4-add-the-order-lookup-snippet-to-your-website","published_at":"2022-05-28T17:24:45+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43119107997948","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"65.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"None","admin_graphql_api_id":"gid://shopify/ProductVariant/43119107997948"}],"images":[{"id":"37549195198716","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/936f22b767a86e456ffda4c62e41ff52.jpg?v=1653738885"}],"options":{"name":"Title","position":"1","values":["Default Title"]}},"6983883063479":{"title":"live test oldpage","handle":"live-test-oldpage","published_at":"2022-04-30T15:50:12+05:30","vendor":"Original Ancestry APP","product_type":"","tags":"","variants":[{"id":"43006978883836","title":"Default Title","option1":"Default Title","option2":"None","option3":"None","sku":"","price":"3.00","grams":"0","image_id":"None","inventory_quantity":"0","compare_at_price":"5.00","admin_graphql_api_id":"gid://shopify/ProductVariant/43006978883836"}],"images":[{"id":"37372904472828","variant_ids":[],"src":"https://cdn.shopify.com/s/files/1/0622/4202/9820/products/4d5eeecc6352a81be06530bee3bee32d.jpg?v=1651314012"}],"options":{"name":"Title","position":"1","values":["Default Title"]}}}}');
        //refreshCarouselListings(pincode_products,pincode);
        //updateAddtocart(pincode_products,pincode);
        if(location.pathname == "/cart"){
          //refreshCart(pincode_products,pincode);
        }
        if(location.pathname.indexOf('/products/') > -1){
//           Shopify.Products.showRecentlyViewed(
//             {
//               howManyToShow: 10,
//               wrapperId: 'recently_viewed_products_box',
//               onComplete: ''
//             }
//           );
        }
      });
  }
}

function updateAddtocart(pincode_products,pincode){
  jQuery('[name="add"]').each(function(i,e){
    let p_id = $(e).data('product-id');
    if((typeof pincode_products != undefined) && (typeof pincode_products != 'undefined') && (typeof pincode_products != null) && (typeof pincode_products != '')){
      if((typeof p_id != undefined) && (typeof p_id != 'undefined') && (typeof p_id != null) && (typeof p_id != '')){
        if((typeof pincode_products[p_id] != undefined) && (typeof pincode_products[p_id] != 'undefined') && (typeof pincode_products[p_id] != null) && (typeof pincode_products[p_id] != '')){
          $(e).show();
        }else{
          $(e).show();
          $(e).find('span').text('Unavailable for '+pincode);
        }
      }else{
        $(e).find('span').text('Unavailable');
      }
    }else{
      $(e).find('span').text('Unavailable');
    }
  });
}

function refreshCart(pincode_products,pincode){
  if((typeof pincode_products != undefined) && (typeof pincode_products != 'undefined') && (typeof pincode_products != null) && (typeof pincode_products != '')){
    let products = pincode_products;
    if(jQuery('[data-cart-box]')){
      jQuery('[data-cart-box]').each(function(i,e){
        let box = jQuery(e).data('cart-box');
        let element_id = jQuery(e).attr('id');
        let item_ids = jQuery(e).data('products');
        let template_data = '';
        let cart_total = 0;
        let j = 0;
        if(item_ids){
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          fetch(`/cart`, config).then((response) => response.json()).then((response) => {
//             console.log(response.items);
            if((response.items) && (response.items.length > 0)){
              $.each(response.items,function(key,item){
                let p_id = item.product_id;
                if((typeof products[p_id] != undefined) && (typeof products[p_id] != 'undefined') && (typeof products[p_id] != null) && (typeof products[p_id] != '')){
                  let image_html = '';
                  if(item.image){
                    image_html += '<a href="/products/'+item.handle+'" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>';
                    image_html += '<img class="cart-item__image" src="'+item.featured_image.url+'" alt="'+item.featured_image.alt+'" loading="lazy" width="150" height="'+Math.ceil(150/item.featured_image.aspect_ratio)+'" />';
                  }
                  let discount_html = '';
                  if(item.discounts){
                    $.each(item.discounts,function(k,dis){
                      discount_html += '<li class="discounts__discount">';
                      discount_html += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-{{ settings.accent_icons }}" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor" /></svg>';
                      discount_html += dis.title;
                      discount_html += '</li>';
                    });
                  }
                  let variant_html = '';
                  if (item.product_has_only_default_variant == false){
                    variant_html += '<dl>';
                    if ((item.options_with_values) && (item.options_with_values.length > 0)){
                      $.each(item.options_with_values,function(k,opt){
                        variant_html += '<div class="product-option">';
                        variant_html += '<dt>'+opt.name+': </dt>';
                        variant_html += '<dd>'+opt.value+'</dd>';
                        variant_html += '</div>';
                      });
                    }
                    if ((item.properties) && (item.properties.length > 0)){
                      variant_html += '<div class="product-option">';
                      $.each(item.properties,function(k,prop){
                        variant_html += '<dt>'+k+'</dt>';
                        variant_html += '<dd>'+prop+'</dd>';
                      });
                      variant_html += '</div>';
                    }
                    if(item.selling_plan){
                      variant_html += '<p class="product-option">'+item.selling_plan+'<p>';
                    }
                  }
                  
                  let price_html = '';
                  if(item.original_line_price != item.final_line_price){
                    price_html += '<dl class="cart-item__discounted-prices">';
                    price_html += '<dt class="visually-hidden">Regular price</dt>';
                    price_html += '<dd>';
                    price_html += '<s class="cart-item__old-price price price--end">';
                    price_html += Shopify.formatMoney(item.original_line_price,Shopify.money_format);
                    price_html += '</s>';
                    price_html += '</dd>';
                    price_html += '<dt class="visually-hidden">Sale price</dt>';
                    price_html += '<dd class="price price--end">';
                    price_html += Shopify.formatMoney(item.final_line_price,Shopify.money_format);
                    price_html += '</dd>';
                    price_html += '</dl>';
                  }else{
                    price_html += '<span class="price price--end">';
                    price_html += Shopify.formatMoney(item.original_line_price,Shopify.money_format);
                    price_html += '</span>';
                  }

                  let itemData = {
                    'index': (j+1),
                    'image_html': image_html,
                    'url': item.url,
                    'title': item.title,
                    'vendor': item.vendor,
                    'discount_html': discount_html,
                    'quantity': item.quantity,
                    'arial_label': 'Quantity for '+item.title,
                    'remove_url': '/cart/change?id='+item.key+'&quantity=0',
                    'variant_html' : variant_html,
                    'discount_html': discount_html,
                    'price_html': price_html
                  }
                  let temp_data = $(".template_pro_"+box).tmpl(itemData);
                  var outer = temp_data[0].innerHTML;
                  temp_data[0].innerHTML = outer.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
                  template_data += '<tr class="cart-item" id="CartItem-'+(j+1)+'">'+temp_data[0].innerHTML+'</tr>';
                  cart_total += item.line_price;
                  j = j + 1;
                }else{
                  removeCartItem('/cart/change?id='+item.key+'&quantity=0');
                }
              });
              if(j == 0){
                location.reload();
              }else{
                jQuery('.totals__subtotal-value').text(Shopify.formatMoney(cart_total,Shopify.money_format));
                document.querySelector("#"+element_id+" tbody").innerHTML = template_data;
              }
            }
          });
        }
      });
    }
  }else{
    console.log('here');
    clearCart();
  }
}

function refreshCarouselListings(pincode_products,pincode){
  if((typeof pincode_products != undefined) && (typeof pincode_products != 'undefined') && (typeof pincode_products != null) && (typeof pincode_products != '')){
    let products = pincode_products;
    if(jQuery('[data-custom-box]')){
      jQuery('[data-custom-box]').each(function(i,e){
        let box = jQuery(e).data('custom-box');
        let item_ids = jQuery(e).data('products').toString();
        let limit = parseInt(jQuery(e).data('products-limit'));
        if((box == 'list') && (parseInt(jQuery('[data-next-link]').val()) > 0)){
          limit = limit * parseInt(jQuery('[data-next-link]').val());
        }
        let j = 0;
        let element_id = jQuery(e).attr('id');
        let template_data = '';
        if((typeof item_ids != undefined) && (typeof item_ids != 'undefined') && (item_ids != '') && (item_ids != null)){
          if(item_ids.indexOf(',') > -1){
            item_ids = item_ids.split(',');
          }else{
            item_ids = [item_ids];
          }
          jQuery(item_ids).each(function(key,id){
            id = parseInt(id);
            if(j < limit){
              if((typeof products[id] != undefined) && (typeof products[id] != 'undefined') && (products[id] != '') && (products[id] != null)){
                let product = products[id];
                let current_variant = product.variants[0];
                let price = current_variant.price;
                let c_price = current_variant.compare_at_price;
                let proTag_html = '';
                //console.log(current_variant);
                let price_html = '<span class="offer-price">'+Shopify.formatMoney(price,Shopify.money_format)+'</span>';
                let featured_image = ((product.images != null) && (product.images != '')) ? product.images[0].src : 'https://cdn.shopify.com/s/files/1/0599/0206/6871/files/placeholder.png?v=1654610148';
                if((c_price != null) && (c_price != 'null')  && (c_price != 'None') && (c_price != '') && (c_price > price)){
                  let discount = Math.ceil((( parseFloat(c_price) - parseFloat(price) ) * 100 ) / parseFloat(c_price));
                  proTag_html += '<div class="pro-tag"><span class="tag-data">save '+discount+'%</span></div>';
                  price_html += '<span class="compare-price">'+Shopify.formatMoney(c_price,Shopify.money_format)+'</span>';
                }
                if ((typeof product.tags != undefined) && (typeof product.tags != 'undefined') && (product.tags != null) && (product.tags != 'None') && (product.tags != '')) {
                  if(product.tags.indexOf(',') > -1){
                    product.tags = product.tags.split(',');
                  }else{
                    product.tags[0] = product.tags;
                  }
                  if(jQuery.inArray("new", product.tags) !== -1){
                    proTag_html += '<div class="pro-tag new"><span class="tag-data">NEW</span></div>';
                  }
                }
                price_html += '<span class="regular-price"></span>';
                let itemData = {
                  'title': product.title,
                  'handle': product.handle,
                  'vendor': product.vendor,
                  'proTag_html': proTag_html,
                  'price_html' : price_html,
                  'featured_image' : featured_image,
                  'price' : price,
                  'cprice' : c_price
                }
                let temp_data = $(".template_pro_"+box).tmpl(itemData);
                var outer = temp_data[0].innerHTML;
                temp_data[0].innerHTML = outer.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
                template_data += '<div class="product-item">'+temp_data[0].innerHTML+'</div>';
                j = j + 1;
              }else{
                console.log(key,' == ',id);
              }
            }else{
              return false;
            }
          });
          if((template_data == null) || (template_data == '')){
            if(pincode == '000000'){
              template_data = '<p class="error_message">No products available</p>';
            }else{
              template_data = '<p class="error_message">No products available for PINCODE : '+pincode+' </p>';
            }
          }
        }else{
          if(pincode == '000000'){
            template_data = '<p class="error_message">No products available</p>';
          }else{
            template_data = '<p class="error_message">No products available for PINCODE : '+pincode+' </p>';
          }
        }
        if(jQuery("#"+element_id+" .product-list").hasClass('slick-initialized')){
          jQuery("#"+element_id+" .product-list").slick('unslick');
        }
        document.querySelector("#"+element_id+" .product-list").innerHTML = '';
		//console.log(template_data);

        //var finalHTML = new DOMParser().parseFromString(template_data, "text/xml");
        //document.querySelector("#"+element_id+" .product-list").insertAdjacentHTML('beforeend', finalHTML);

        let next_link = (jQuery('[data-next-link]').val()) ? parseInt(parseInt(jQuery('[data-next-link]').val())+1) : 2;
        let loader = '<input type="hidden" value="'+next_link+'" data-next-link>';
        jQuery('[data-next-link], .load-more_wrap').remove();
        if((box == 'list') && (j >= limit)){
          loader += '<div class="load-more_wrap"><button class="btn js-load-more btn--primary hero__btn"><span load-more-text class="button">Load More</span><span class="hide" loader><img src="https://cdn.shopify.com/s/files/1/0599/0206/6871/t/17/assets/loader.gif" /></span></button></div>';
          document.querySelector(".grid-loader").insertAdjacentHTML('beforeend', loader);
        }

        document.querySelector("#"+element_id+" .product-list").innerHTML = template_data;
        if(box == 'carousel'){
          document.addEventListener("DOMContentLoaded, shopify:section:load, shopify:section:unload, shopify:section:select, shopify:section:deselect, shopify:block:select, shopify:block:deselect", loadSlider('#'+element_id+' .product-list', '.product-item'));
        }
      });
    }
  }
}

function pincodeBox(response,pincode){
  console.log(response);
  if((response == true) || (response == "true")){
    jQuery("#zip_delivery").hide();
    jQuery(".carousel__button").click();
    localStorage.setItem("pincode",pincode);
    loadPincodeProducts();
  }else{
    jQuery("#zip_delivery").text('We are not serving for this picode yet.').show();
  }
}

function getInputValue(){
  var inputVal ="";
  inputVal = document.getElementById("ppin").value;
  let pincode = localStorage.getItem('pincode');
  if(pincode == undefined || pincode == 'undefined' || pincode == null || pincode != '' || pincode != inputVal){
    if (inputVal != null && inputVal != 'undefined' && inputVal != '' && inputVal.length == 6 && inputVal != '000000'){ 
      $("#zip_delivery").hide();
      verifyPincodeAjax('https://'+Shopify.app_url+'/validate_pincode?pincode='+inputVal+'&shop_name='+Shopify.shop,inputVal);
    }
    else{
      $("#zip_delivery").text('Please enter valid pincode.').show();
    }
  }else{
    $("#zip_delivery").text('Please enter valid pincode.').show();
  }
}

function custom_create_checkout(response,storefront_token){
  let shipping_firstname = ((typeof $('#shipping_firstname').val() != undefined) && (typeof $('#shipping_firstname').val() != 'undefined') && ($('#shipping_firstname').val() != '') && ($('#shipping_firstname').val() != null)) ? $('#shipping_firstname').val() : 'Shah';
  let shipping_lastname = ((typeof $('#shipping_lastname').val() != undefined) && (typeof $('#shipping_lastname').val() != 'undefined') && ($('#shipping_lastname').val() != '') && ($('#shipping_lastname').val() != null)) ? $('#shipping_lastname').val() : 'Chintan';
  let shipping_email = ((typeof $('#shipping_email').val() != undefined) && (typeof $('#shipping_email').val() != 'undefined') && ($('#shipping_email').val() != '') && ($('#shipping_email').val() != null)) ? $('#shipping_email').val() : '3iwebexperts@gmail.com';
  let shipping_company = ((typeof $('#shipping_company').val() != undefined) && (typeof $('#shipping_company').val() != 'undefined') && ($('#shipping_company').val() != '') && ($('#shipping_company').val() != null)) ? $('#shipping_company').val() : '3iwebexperts';
  let shipping_date = ((typeof $('#shipping_date').val() != undefined) && (typeof $('#shipping_date').val() != 'undefined') && ($('#shipping_date').val() != '') && ($('#shipping_date').val() != null)) ? $('#shipping_date').val() : '12-04-2022';
  let shipping_address1 = ((typeof $('#shipping_address1').val() != undefined) && (typeof $('#shipping_address1').val() != 'undefined') && ($('#shipping_address1').val() != '') && ($('#shipping_address1').val() != null)) ? $('#shipping_address1').val() : 'address 1';
  let shipping_address2 = ((typeof $('#shipping_address2').val() != undefined) && (typeof $('#shipping_address2').val() != 'undefined') && ($('#shipping_address2').val() != '') && ($('#shipping_address2').val() != null)) ? $('#shipping_address2').val() : 'address 2';
  let shipping_city = ((typeof $('#shipping_city').val() != undefined) && (typeof $('#shipping_city').val() != 'undefined') && ($('#shipping_city').val() != '') && ($('#shipping_city').val() != null)) ? $('#shipping_city').val() : 'Mehsana';
  let shipping_state = ((typeof $('#shipping_state').val() != undefined) && (typeof $('#shipping_state').val() != 'undefined') && ($('#shipping_state').val() != '') && ($('#shipping_state').val() != null)) ? $('#shipping_state').val() : 'Gujarat';
  let shipping_country = ((typeof $('#shipping_country').val() != undefined) && (typeof $('#shipping_country').val() != 'undefined') && ($('#shipping_country').val() != '') && ($('#shipping_country').val() != null)) ? $('#shipping_country').val() : 'India';
  let shipping_zip = ((typeof $('#shipping_zip').val() != undefined) && (typeof $('#shipping_zip').val() != 'undefined') && ($('#shipping_zip').val() != '') && ($('#shipping_zip').val() != null)) ? $('#shipping_zip').val() : '382421';
  let shipping_phone = ((typeof $('#shipping_phone').val() != undefined) && (typeof $('#shipping_phone').val() != 'undefined') && ($('#shipping_phone').val() != '') && ($('#shipping_phone').val() != null)) ? $('#shipping_phone').val() : '9664970476';
  let shipping_note = ((typeof $('#shipping_note').val() != undefined) && (typeof $('#shipping_note').val() != 'undefined') && ($('#shipping_note').val() != '') && ($('#shipping_note').val() != null)) ? $('#shipping_note').val() : 'cart Note';
  let cart_token = response.token;
  let mutation = `mutation checkoutCreate($input: CheckoutCreateInput!) {
    checkoutCreate(input: $input) {
      checkout {
        id
        webUrl
      }
      checkoutUserErrors {
        code
        field
        message
      }
      queueToken
    }
  }`;
  let lineItems = [];
  $.each(response.items,function(k,r){
    let lineitem = {
      "variantId" : btoa('gid://shopify/ProductVariant/'+r.variant_id),
      "quantity": r.quantity
    };
    lineItems.push(lineitem);
  });
  let variables = {
    "input": {
      "allowPartialAddresses": true,
      "lineItems": lineItems,
      "customAttributes": [
        {
          "key": "delivery_date",
          "value": shipping_date
        }
      ],
      "email": shipping_email,
      "note": shipping_note,
      "presentmentCurrencyCode": (Shopify.currency.active) ? Shopify.currency.active : "INR",
      "shippingAddress": {
        'phone': shipping_phone,
        'lastName': shipping_lastname,
        'firstName': shipping_firstname,
        'address1': shipping_address1,
        'address2': shipping_address2,
        'province': shipping_state,
        'country': shipping_country,
        'zip': shipping_zip,
        'city': shipping_city
      }
    }
  };
  let settings = {
    'async': true,
    'crossDomain': true,
    'url': 'https://'+Shopify.shop+'/api/2022-04/graphql.json',
    'method': 'POST',
    'headers': {
      'X-Shopify-Storefront-Access-Token': storefront_token,
      'Content-Type': 'application/json',
    },
    'data': JSON.stringify({query:mutation, variables: variables})
  };
  $.ajax(settings).done(function (response) {
    let errors = response.data['checkoutCreate']['checkoutUserErrors'];
    if(errors.length > 0){
      return displayErrorMessage(errors);
    }else{
      let checkout_response = response.data['checkoutCreate']['checkout'];
      localStorage.setItem("checkout", JSON.stringify(checkout_response));
      $(location).prop('href', response.data['checkoutCreate']['checkout']['webUrl']);
    }
  });
}

function update_checkout_lineitems(response,storefront_token,checkoutId){
  let mutation = `mutation checkoutLineItemsReplace($checkoutId: ID!, $lineItems: [CheckoutLineItemInput!]!) {
      checkoutLineItemsReplace(checkoutId:$checkoutId, lineItems:$lineItems) {
        userErrors {
          code
          field
          message
        }
        checkout {
          id
          webUrl
        }
      }
    }`;
  let lineItems = [];
  $.each(response.items,function(k,r){
    let lineitem = {
      "variantId" : btoa('gid://shopify/ProductVariant/'+r.variant_id),
      "quantity": r.quantity
    };
    lineItems.push(lineitem);
  });
  let variables = {
    'lineItems': lineItems,
    'checkoutId': checkoutId
  }
  let settings = {
    'async': true,
    'crossDomain': true,
    'url': 'https://'+Shopify.shop+'/api/2022-04/graphql.json',
    'method': 'POST',
    'headers': {
      'X-Shopify-Storefront-Access-Token': storefront_token,
      'Content-Type': 'application/json',
    },
    'data': JSON.stringify({query:mutation,variables:variables})
  };
  $.ajax(settings).done(function (response) {
    let errors = response.data['checkoutLineItemsReplace']['userErrors'];
    if(errors.length > 0){
      return displayErrorMessage(errors);
    }else{
      let checkout_response = response.data['checkoutLineItemsReplace']['checkout'];
      localStorage.setItem("checkout", JSON.stringify(checkout_response));
      return update_checkout_address(response,storefront_token,checkoutId);
    }
  });
}

function update_checkout_address(response,storefront_token,checkoutId){
  let shipping_firstname = ((typeof $('#shipping_firstname').val() != undefined) && (typeof $('#shipping_firstname').val() != 'undefined') && ($('#shipping_firstname').val() != '') && ($('#shipping_firstname').val() != null)) ? $('#shipping_firstname').val() : 'Shah';
  let shipping_lastname = ((typeof $('#shipping_lastname').val() != undefined) && (typeof $('#shipping_lastname').val() != 'undefined') && ($('#shipping_lastname').val() != '') && ($('#shipping_lastname').val() != null)) ? $('#shipping_lastname').val() : 'Chintan';
  let shipping_email = ((typeof $('#shipping_email').val() != undefined) && (typeof $('#shipping_email').val() != 'undefined') && ($('#shipping_email').val() != '') && ($('#shipping_email').val() != null)) ? $('#shipping_email').val() : '3iwebexperts@gmail.com';
  let shipping_company = ((typeof $('#shipping_company').val() != undefined) && (typeof $('#shipping_company').val() != 'undefined') && ($('#shipping_company').val() != '') && ($('#shipping_company').val() != null)) ? $('#shipping_company').val() : '3iwebexperts';
  let shipping_date = ((typeof $('#shipping_date').val() != undefined) && (typeof $('#shipping_date').val() != 'undefined') && ($('#shipping_date').val() != '') && ($('#shipping_date').val() != null)) ? $('#shipping_date').val() : '12-04-2022';
  let shipping_address1 = ((typeof $('#shipping_address1').val() != undefined) && (typeof $('#shipping_address1').val() != 'undefined') && ($('#shipping_address1').val() != '') && ($('#shipping_address1').val() != null)) ? $('#shipping_address1').val() : 'address 1';
  let shipping_address2 = ((typeof $('#shipping_address2').val() != undefined) && (typeof $('#shipping_address2').val() != 'undefined') && ($('#shipping_address2').val() != '') && ($('#shipping_address2').val() != null)) ? $('#shipping_address2').val() : 'address 2';
  let shipping_city = ((typeof $('#shipping_city').val() != undefined) && (typeof $('#shipping_city').val() != 'undefined') && ($('#shipping_city').val() != '') && ($('#shipping_city').val() != null)) ? $('#shipping_city').val() : 'Mehsana';
  let shipping_state = ((typeof $('#shipping_state').val() != undefined) && (typeof $('#shipping_state').val() != 'undefined') && ($('#shipping_state').val() != '') && ($('#shipping_state').val() != null)) ? $('#shipping_state').val() : 'Gujarat';
  let shipping_country = ((typeof $('#shipping_country').val() != undefined) && (typeof $('#shipping_country').val() != 'undefined') && ($('#shipping_country').val() != '') && ($('#shipping_country').val() != null)) ? $('#shipping_country').val() : 'India';
  let shipping_zip = ((typeof $('#shipping_zip').val() != undefined) && (typeof $('#shipping_zip').val() != 'undefined') && ($('#shipping_zip').val() != '') && ($('#shipping_zip').val() != null)) ? $('#shipping_zip').val() : '382421';
  let shipping_phone = ((typeof $('#shipping_phone').val() != undefined) && (typeof $('#shipping_phone').val() != 'undefined') && ($('#shipping_phone').val() != '') && ($('#shipping_phone').val() != null)) ? $('#shipping_phone').val() : '9664970476';

  let mutation = `mutation checkoutShippingAddressUpdateV2($shippingAddress: MailingAddressInput!, $checkoutId: ID!) {
                    checkoutShippingAddressUpdateV2(shippingAddress: $shippingAddress, checkoutId: $checkoutId) {
                        checkoutUserErrors {
                            code
                            field
                            message
                        }
                        checkout {
                            id
                            webUrl
                        }
                    }
                }`;
  let variables = {
    'shippingAddress': {
      'phone': shipping_phone,
      'lastName': shipping_lastname,
      'firstName': shipping_firstname,
      'address1': shipping_address1,
      'address2': shipping_address2,
      'province': shipping_state,
      'country': shipping_country,
      'zip': shipping_zip,
      'city': shipping_city
    },
    'checkoutId': checkoutId
  }
  let settings = {
    'async': true,
    'crossDomain': true,
    'url': 'https://'+Shopify.shop+'/api/2022-04/graphql.json',
    'method': 'POST',
    'headers': {
      'X-Shopify-Storefront-Access-Token': storefront_token,
      'Content-Type': 'application/json',
    },
    'data': JSON.stringify({query:mutation,variables:variables})
  };
  $.ajax(settings).done(function (response) {
    let errors = response.data['checkoutShippingAddressUpdateV2']['checkoutUserErrors'];
    if(errors.length > 0){
      return displayErrorMessage(errors);
    }else{
      let checkout_response = response.data['checkoutShippingAddressUpdateV2']['checkout'];
      localStorage.setItem("checkout", JSON.stringify(checkout_response));
      return update_checkout_email(response,storefront_token,checkoutId);
    }
  });
}

function update_checkout_email(response,storefront_token,checkoutId){
  let shipping_email = ((typeof $('#shipping_email').val() != undefined) && (typeof $('#shipping_email').val() != 'undefined') && ($('#shipping_email').val() != '') && ($('#shipping_email').val() != null)) ? $('#shipping_email').val() : '3iwebexperts@gmail.com';
  console.log(shipping_email);

  let mutation = `mutation checkoutEmailUpdateV2($checkoutId: ID!, $email: String!) {
        checkoutEmailUpdateV2(checkoutId: $checkoutId, email: $email) {
            checkoutUserErrors {
                code
                field
                message
            }
            checkout {
                id
                webUrl
            }
        }
    }`;
  let variables = {
    'checkoutId': checkoutId,
    'email': shipping_email
  }
  let settings = {
    'async': true,
    'crossDomain': true,
    'url': 'https://'+Shopify.shop+'/api/2022-04/graphql.json',
    'method': 'POST',
    'headers': {
      'X-Shopify-Storefront-Access-Token': storefront_token,
      'Content-Type': 'application/json',
    },
    'data': JSON.stringify({query:mutation,variables:variables})
  };
  $.ajax(settings).done(function (response) {
    let errors = response.data['checkoutEmailUpdateV2']['checkoutUserErrors'];
    if(errors.length > 0){
      return displayErrorMessage(errors);
    }else{
      let checkout_response = response.data['checkoutEmailUpdateV2']['checkout'];
      localStorage.setItem("checkout", JSON.stringify(checkout_response));
      $(location).prop('href', response.data['checkoutEmailUpdateV2']['checkout']['webUrl']);
    }
  });
}

function displayErrorMessage(errors){
  console.log(errors);
}

function custom_checkout_process(){
  const config = fetchConfig();
  config.method = 'GET';
  let param= {'shop_name': Shopify.shop};
  let path = 'https://'+Shopify.app_url+'/get_storefront_token?shop_name='+Shopify.shop;
  fetch(path, config)
  .then((response) => response.json())
  .then((response) => {
    let storefront_token = response.storefront_access_tokens[0].access_token;
    $.getJSON("/cart.json", function(response){
      if((typeof response != undefined) && (typeof response != 'undefined') && (response != null) && (response != '')){
        if((typeof localStorage.getItem("checkout") != undefined) && (typeof localStorage.getItem("checkout") != 'undefined') && (localStorage.getItem("checkout") != null) && (localStorage.getItem("checkout") != '')){
          let checkout_items = localStorage.getItem("checkout");
          let checkoutId = btoa(JSON.parse(checkout_items).id);
          update_checkout_lineitems(response,storefront_token,checkoutId);
        }else{
          custom_create_checkout(response,storefront_token);
        }
      }
    });
  });  
}

function array_unique(array) {
  var unique = [];
  for ( var i = 0 ; i < array.length ; ++i ) {
    if ( unique.indexOf(array[i]) == -1 ){
      unique.push(array[i]);
    }
  }
  return unique;
}

jQuery(function(){
  Shopify.money_format = document.getElementsByTagName('body')[0].getAttribute('data-format');
  Shopify.app_url = 'shopify.sweedesi.com';
  
  jQuery(document).ready(function () {
    loadPincodeProducts();
  });
  //custom_checkout_process();
});

//================== pincode code end =================





jQuery(document).on("click",".clear_pin",function (e) {
  var pincode = localStorage.getItem('pincode');
  const config = fetchConfig();
  if((typeof pincode != undefined) && (typeof pincode != 'undefined') && (pincode != null) && (pincode != '')){
    e.preventDefault();
    localStorage.removeItem('pincode');
    loadPincodeProducts();
  }
});


jQuery(document).ready(function () {
  if(jQuery('#shopify-section-announcement-bar').length > 0){
    jQuery('#shopify-section-announcement-bar').slick({
      slidesToShow: 1,
      slidesToScroll:1,
      arrows: false,
      fade: false,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 3000,
      speed: 1500,
      dots: false    
    });
  }

  jQuery('#ppin').keypress(function (e) {    
    var charCode = (e.which) ? e.which : event.keyCode        
    if (String.fromCharCode(charCode).match(/[^0-9]/g))    
      return false;
  });    
});



function verify_customer(){
  const config = fetchConfig();
  config.method = 'GET';
//   let param= {'shop_name': Shopify.shop}; 
//   let path = 'https://'+Shopify.app_url+'/get_storefront_token?shop_name='+Shopify.shop;
  let storefront_token;
//   fetch(path, config)
//   .then((response) => response.json())
//   .then((response) => {
//     console.log(response);
//     storefront_token = response.storefront_access_tokens[0].access_token;
  storefront_token = "6d34310a7e05ca93f26b12b0cfb7978f";
  let mutation = `mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
                 customerAccessTokenCreate(input: $input) {
                     customerAccessToken {
                         accessToken
                         expiresAt
                     }
                     customerUserErrors {
                         field
                         message
                         }
                     }
                 }`;
  let variables = {
    "input": {
      "email": '10developer3i@gmail.com',
      "password": '123456'
    }
  };
  let settings = {
    'async': true,
    'crossDomain': true,
    'url': 'https://'+Shopify.shop+'/api/2022-04/graphql.json',
    'method': 'POST',
    'headers': {
      'X-Shopify-Storefront-Access-Token': storefront_token,
      'Content-Type': 'application/json',
    },
    'data': JSON.stringify({query:mutation,variables:variables})
  };
  $.ajax(settings).done(function (response_1) {
    console.log(response_1,"response_1");
  });
  //});
}


// pincode efforts start

function match_contry_name(){
  var contry_name = $("#contry_name").val();
  $('#contry_name_list').empty();
  $.ajax({
    type: "GET",
    url: 'https://'+Shopify.app_url+'/country_suggest',
    data: { 'contry_name': contry_name, 'shop_name': Shopify.shop },
    success: function (response) {
      $('#contry_name_list').empty();
      $('#contry_name_list').append('<span style = "color: red;">'+ response +'</span>');
    }
  });
}
function match_pincode(){
  var product_id = $("#product_id").val();
  var pin_code = $("#pin_code").val();
  var country = $("#contry_list").val();
  var pin_length = pin_code.length;
  $('.product-form__error-message-wrapper').attr('hidden','true');
  $('.product-form__error-message-wrapper .product-form__error-message').text('');
  $('#add_to_cart').prop("disabled", true);
  $('#add_to_cart').hide();
  let move_ahead = true;
  if (pin_length == 6){
    $.ajax({
      type: "GET",
      url: 'https://'+Shopify.app_url+'/pin_product',
      data: { 'product_id': product_id, 'pin_code':pin_code, 'country': country.split('_')[0], 'shop_name': Shopify.shop},
      success: function (response) {
        if((response == "true") || (response == "True") || (response == true)){
          $.getJSON('/cart.js',function(cart_response){
            let cart_count = parseInt(cart_response.item_count);
            if((typeof localStorage.getItem('pin') != 'undefined') && (typeof localStorage.getItem('pin') != undefined) && (localStorage.getItem('pin') != null) && (localStorage.getItem('pin') != '') && (cart_count > 0) && (localStorage.getItem('pin') != pin_code)){
              const fancybox = new Fancybox([
                {
                  src: "#loc_pop",
                  type: "inline",
                }
              ]);
              move_ahead = false;
            }
            if(move_ahead == true){
              localStorage.setItem('pin', pin_code);
              localStorage.setItem('contrey', country);
              $("#add_to_cart").prop("disabled", false);
              $('#add_to_cart').show();
            }
          });
        }else{
          $('.product-form__error-message-wrapper').removeAttr('hidden');
          $('.product-form__error-message-wrapper .product-form__error-message').text('This product is not available for your pin code, please try another product.');
        }
      }
    });
  }else{
    $('.product-form__error-message-wrapper').removeAttr('hidden');
    $('.product-form__error-message-wrapper .product-form__error-message').text('Please enter valid pincode.');
  }
}
//   .............
$( document ).ready(function() {
  var product_id = $("#product_id").val();
  if($("#product_id")){
    $.ajax({
      type: "GET",
      url: 'https://'+Shopify.app_url+'/all_contrey',
      data: { 'product_id': product_id, 'shop_name': Shopify.shop },
      success: function (response) {
        if ((response.contry_pin_detail != undefined) && (response.contry_pin_detail != null) && (response.contry_pin_detail != '') ){
          $.each(response.contry_pin_detail, function (key){
            $('#contry_list').append(
              $('<option>', {
                pincode: response.contry_pin_detail[key].pin_code,
                pincode_count: response.contry_pin_detail[key].pin_count,
                //value: response.contry_pin_detail[key].contrey_name +"_"+ response.contry_pin_detail[key].pin_count +"_"+ response.contry_pin_detail[key].pin_code, 
                value: response.contry_pin_detail[key].contrey_name +"_"+ response.contry_pin_detail[key].pin_count,
                text: response.contry_pin_detail[key].contrey_name
              })
            );
          });
          var local_pin = (localStorage.getItem('pin'));
          var local_contrey = (localStorage.getItem('contrey'));
          if((typeof local_contrey != undefined) && (typeof local_contrey != 'undefined') && (local_contrey != '') && (local_contrey != null)){
            let c_country = local_contrey.split('_')[0];
            if((typeof $('option[value^="'+c_country+'"]') != undefined) && (typeof $('option[value^="'+c_country+'"]') != 'undefined') && ($('option[value^="'+c_country+'"]').length > 0)){
              $('#pin_code').val(local_pin);
              $('#pin_code').attr('value',local_pin);
              $('#contry_list option[value^="'+c_country+'"]').prop('selected',true).trigger('change');
            }
          }
        }else{
          $('.product-form__error-message-wrapper').removeAttr('hidden');
          $('.product-form__error-message-wrapper .product-form__error-message').text('This product is not available for now.');
          $("#contry_list").hide();
        }
      }
    });
  }
});

$(document).on("change","#contry_list",function(){
  var selected_cintry = $('#contry_list').val();
  console.log(selected_cintry);
  if((typeof selected_cintry != 'undefined') && (typeof selected_cintry != undefined) && (selected_cintry != null) && (selected_cintry != '')){
    var pin_count = selected_cintry.split("_");
    var s_pincode = $('#contry_list option:selected').attr('pincode');
    var product_id = $("#product_id").val();
    $("#pin_code").hide();
    if(parseInt(pin_count[1]) == 1){
      $("#pin_code").val(s_pincode);
      $('#pin_code').attr('value',s_pincode);
    }else if(parseInt(pin_count[1]) > 1){
      if((typeof localStorage.getItem('contrey') != 'undefined') && (typeof localStorage.getItem('contrey') != undefined) && (localStorage.getItem('contrey') != null) && (localStorage.getItem('contrey') != '')){
        if(selected_cintry.split('_')[0] != localStorage.getItem('contrey').split('_')[0]){
          $("#pin_code").val('');
        }else{
          $("#pin_code").val(localStorage.getItem('pin'));
          $('#pin_code').attr('value',localStorage.getItem('pin'));
        }
      }else{
        $("#pin_code").val('');
      }
      $("#pin_code").show();
    }
  }else{
    $("#pin_code").hide();
  }
  match_pincode();
});

function cancelProcess(){
  var local_pin = (localStorage.getItem('pin'));
  var local_contrey = (localStorage.getItem('contrey'));
  if((typeof $('option[value="'+local_contrey+'"]') != undefined) && (typeof $('option[value="'+local_contrey+'"]') != 'undefined') && ($('option[value="'+local_contrey+'"]').length > 0)){
    $('#pin_code').val(local_pin);
    $('#contry_list option[value="'+local_contrey+'"]').prop('selected',true).trigger('change');
  }
  $('.carousel__button').click();
}

function clearBasket() {
  var product_id = $("#product_id").val();
  var pin_code = $("#pin_code").val();
  var country = $("#contry_list").val();
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  fetch('/cart/clear.js', config).then((response) => {
    if(response.status == 200){
      localStorage.setItem('pin', pin_code);
      localStorage.setItem('contrey', country);
      $("#add_to_cart").prop("disabled", false);
      $('#add_to_cart').show();
      custom.getRenderCartDrawer();
    }
    $('.carousel__button').click();
  });
}